<script lang="ts">
  import type { Snippet } from 'svelte'

  import {
    EVALUATION_CONFIG_ERROR_MESSAGE,
    EVALUATION_CONFIG_LOADING_MESSAGE,
    EVALUATION_DISABLED_MESSAGE,
    type EvaluationEntitlementState,
  } from './evaluation-entitlement.svelte'

  interface Props {
    entitlementState: EvaluationEntitlementState
    disabled?: boolean
    children?: Snippet
  }

  const { entitlementState, disabled = false, children }: Props = $props()
  const renderedStatus = $derived(!disabled ? entitlementState.status : 'disabled')
</script>

{#if renderedStatus === 'enabled'}
  {@render children?.()}
{:else if renderedStatus === 'loading'}
  <p>{EVALUATION_CONFIG_LOADING_MESSAGE}</p>
{:else if renderedStatus === 'error'}
  <p>{EVALUATION_CONFIG_ERROR_MESSAGE}</p>
{:else if renderedStatus === 'disabled'}
  <p>{EVALUATION_DISABLED_MESSAGE}</p>
{/if}
